















































































import {Component, Mixins} from "vue-property-decorator";
import Dialog from "@/mixins/Dialog";
import ChooseFile from "@/components/ChooseFile.vue";
import { system_info } from "@/core/utils";
import ConfirmDialog from "@/components/confirmDialog.vue";

@Component({
  components: {
    'choose-file':ChooseFile,
    'confirm-dialog' : ConfirmDialog

  }
})
export default class InvestorApplyDialog extends Mixins(Dialog){
  //弹窗显示
  private dialog:any={
    confirmDialog:false
  }


  // 表单参数
  private params:any={
    plat_id: null ,
    type:1,     //1.投资人 2.资管公司
    legal_name:'',
    preference:'',
    email:'',
    contact:'',
    organ_name:'',
    intro:'',
    cases:'',
    logo:[],
    control_scale:'',     //注册资本
  }

  //校验参数
  private rules:any={
    legal_name:[
      { required: true, message: '请输入投资人姓名', trigger: 'blur' }
    ],
    email:[
      { required: true, message: '请输入邮箱', trigger: 'blur' }
    ],
    contact:[
      { required: true, message: '请输入投资人手机号', trigger: 'blur' }
    ],
    organ_name:[
      { required: true, message: '请输入企业名称', trigger: 'blur' }
    ],
    control_scale:[
      { required: true, message: '请输入注册资本', trigger: 'blur' }
    ],
    preference:[
      { required: true, message: '请输入投资偏好' , trigger: 'blur' }
    ],
    intro:[
      { required: true, message: '请输入机构介绍', trigger: 'blur' }
    ],
    cases:[
      { required: true, message: '请输入投资案例', trigger: 'blur' }
    ],
    logo:[
      { required: true, message: '请上传投资人/机构图片', trigger: 'blur' }
    ],
  }

  public open( ){
    this.params.plat_id = system_info.get('id') ;
    this.dialog_visible = true ;
  }

  //上传文件
  private uploadFile(event:any){
    this.$set( this.params.logo , this.params.logo.length  , event  )
  }

  //提交
  private submit(){
    let form = (this.$refs as any).dialog_form;
    form.validate((valid:any) => {
      if (valid) {
        let data :any={};
        Object.assign( data , this.params );
        if(this.params.logo.length > 0){
          data.logo = this.params.logo[0].filePath.split('.com/')[1] ;
        }
        console.log( data , '提交投资人认证申请')
        this.loading = true ;
        this.$noSign.post(this.$URL.INVESTOR_APPLY , data ).then((res:any)=>{
          this.loading = false;
          if(res.code == 1){
            console.log( res , data, '投资人申请成功，待审核');
            (this.$refs as any).confirmDialog.open( '提交成功，待审核' , 'success' )
          }else{
            this.$message.error( res.msg )
          }
        })
      }
    });
  }


  private complete(){
    this.onClose()  ;
  }

  public onClose(){
    let form = (this.$refs as any).dialog_form;
    form.resetFields();
    this.dialog_visible = false ;
  }
}
